import React from 'react';
import Icon from '../../../components/AppIcon';

const EmailDeliverySummaryCard = ({ title, value, icon, color, subtitle }) => {
  const colorClasses = {
    blue: 'bg-blue-50 text-blue-600',
    green: 'bg-green-50 text-green-600',
    red: 'bg-red-50 text-red-600',
    purple: 'bg-purple-50 text-purple-600',
    yellow: 'bg-yellow-50 text-yellow-600'
  };

  return (
    <div className="bg-white rounded-lg shadow-sm p-6 border border-neutral-200">
      <div className="flex items-center justify-between mb-4">
        <div className={`p-3 rounded-lg ${colorClasses?.[color] || colorClasses?.blue}`}>
          <Icon name={icon} size={24} />
        </div>
      </div>
      <div>
        <p className="text-sm text-neutral-600 mb-1">{title}</p>
        <p className="text-3xl font-bold text-neutral-900">{value}</p>
        {subtitle && (
          <p className="text-sm text-neutral-500 mt-1">{subtitle}</p>
        )}
      </div>
    </div>
  );
};

export default EmailDeliverySummaryCard;